import { failure, success } from 'utils/actionTypesHelpers';

export const CHECK_EMAIL_AVAILABILITY = 'CHECK_EMAIL_AVAILABILITY';
export const CHECK_EMAIL_AVAILABILITY_FAILURE = failure(CHECK_EMAIL_AVAILABILITY);
export const CHECK_EMAIL_AVAILABILITY_SUCCESS = success(CHECK_EMAIL_AVAILABILITY);
